module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAclBMVEUAAADKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysr1Pl5+AAAAJXRSTlMAYAPu4r0S+d7PwbedfDYpHxrz6saplYuEcWZIRTzl2rBVLy0IPF4OLQAAALJJREFUOMu9kkcOwlAMRH9JL6T30PH9r8gG8tsoERvedp40lm32E8HcxbL2/LGAsRglfckCN39cSUPe7fxEFrNVH5KNOYhPDr5ZACg1IUNCrgkXot2OihDekRAyRYuERuWvCAmpEhJC8C0fYF6LTSBIrxqm1MOL3B0iPToFN57p5gor04ld4WwIPMSConGExRQSPKQiyAderLowMYB2s6hEQv/5lC5fBENUsWwz/hTsr7wBHT9F5WsZ7mEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/management-link-icon.png
// module id = 3gF9
// module chunks = 0